export const  unitTypeList = [
  {
    name: 'Acres',
    value: 'Acres'
  },
  {
    name: 'Barel',
    value: 'Barel'
  },
  {
    name: 'Bushel',
    value: 'Bushel'
  },
  {
    name: 'Each',
    value: 'Each'
  },
  {
    name: 'Feet',
    value: 'Feet'
  },
  {
    name: 'Foot',
    value: 'Foot'
  },
  {
    name: 'Gallon',
    value: 'Gallon'
  },
  {
    name: 'Head',
    value: 'Head'
  },
  {
    name: 'Hectare',
    value: 'Hectare'
  },
  {
    name: 'Inch',
    value: 'Inch'
  },
  {
    name: 'Item',
    value: 'Item'
  },
  {
    name: 'Joint',
    value: 'Joint'
  },
  {
    name: 'Kilogram',
    value: 'Kilogram'
  },
  {
    name: 'Liter',
    value: 'Liter'
  },
  {
    name: 'Meter',
    value: 'Meter'
  },
  {
    name: 'Pair',
    value: 'Pair'
  },
  {
    name: 'Pound',
    value: 'Pound'
  },
  {
    name: 'Quarter',
    value: 'Quarter'
  },
  {
    name: 'Ton',
    value: 'Ton'
  },
  {
    name: 'Tonne',
    value: 'Tonne'
  },
  {
    name: 'Unit',
    value: 'Unit'
  },
  {
    name: 'Yard',
    value: 'Yard'
  }
];

